import { getApiUrl } from "../utils/get-api-url";
import { init } from "../units/launch-darkly";
import { LD_USER_DEFAULT_CONTEXT } from "../constants";

declare let CONFIG: any;

export const requestUsername = async (email: string) => {
  const flags = await init({
    key: CONFIG.envConfig.launchDarklyID,
    context: LD_USER_DEFAULT_CONTEXT
  });

  const hasUserServices = flags["user-services"] === true;
  let apiUrl, fullUrl;

  if (hasUserServices) {
    apiUrl = getApiUrl("userservices");
    fullUrl = `${apiUrl}/forgotUsername`;
  } else {
    apiUrl = getApiUrl("agenciesservice");
    fullUrl = `${apiUrl}/forgotusername?email=${encodeURIComponent(email)}`;
  }

  const response = await fetch(fullUrl, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    ...(hasUserServices && {
      body: JSON.stringify({
        email,
        client: "agentportal"
      })
    })
  });

  const { statusText, ok } = response;
  const text = await response.text();
  if (!ok) throw new Error(statusText || text);
  return Promise.resolve();
};
